import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import * as serviceWorker from './serviceWorker';

import App from './components/App';
import Firebase, { FirebaseContext } from './components/Firebase';
import AppAlertProvider from './components/AppAlertProvider';

const savedDarkMode = (() => {
  try {
    return localStorage.getItem('darkMode') === 'true';
  } catch (e) {
    return false;
  }
})();

if (savedDarkMode) {
  document.body.classList.add('dark-mode');
  document.documentElement.classList.add('dark-mode');
} else {
  document.body.classList.remove('dark-mode');
  document.documentElement.classList.remove('dark-mode');
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <AppAlertProvider>
      <App />
    </AppAlertProvider>
  </FirebaseContext.Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
